<div class="detail-panel">
  <div class="flex justify-end items-center">
    <button (click)="close()" class="button button-primary button-sm" title="Cerrar detalles">
      <i class="fas fa-times" aria-hidden="true"></i>
    </button>
  </div>
  
  <h2 class="text-primary-500">{{ maintenanceType?.name }}</h2>

  <ul>
    <li>
      <strong>ID:</strong> {{ maintenanceType?.id }}
    </li>
    <li>
      <strong>Tipo de Vista:</strong> {{ maintenanceType?.viewType?.name }}
    </li>
    <li>
      <strong>Estado:</strong> {{ maintenanceType?.disabled ? 'Deshabilitado' : 'Habilitado' }}
    </li>
  </ul>

  <div class="flex justify-center mt-6 space-x-4">
    <button (click)="close()" class="button button-outlined-primary">Cancelar</button>
    <a [routerLink]="['/maintenance-types/update', maintenanceType?.id]" class="button button-primary">Editar</a>
  </div>
</div>
  